import { render } from "./ProfileDropDown.vue?vue&type=template&id=01477cd8&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"

import "./ProfileDropDown.vue?vue&type=style&index=0&id=01477cd8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01477cd8"]])

export default __exports__